import validation from './validation.js';

export default {
  sendButton: 'Отправить',
  checkAll: 'Выбрать все',
  sector: 'Сектор',
  row: 'Ряд',
  place: 'Место',
  price: 'Цена',
  ruble: '₽',
  clear: 'Очистить',
  pay: 'Оплатить',

  validation,

  verification: {
    title: 'Верификация пользователя',
    titleTooltip: 'Верификация дает право на\xa0персональный выкуп мест на\xa0матч',
    status: {
      unactivated: 'Подтвердите активацию аккаунта на\xa0вашей почте',
      unverified: 'Вы не верифицированы',
      verified: 'Вы верифицированы',
    },
    formPlaceholders: {
      firstName: 'Имя',
      lastName: 'Фамилия',
      patronymic: 'Отчество',
      phone: 'Телефон',
      subscription: 'Номер абонемента',
    },
    error: {
      unknownStatus: ({ named }) => `Неизвестный статус верификации ${named('number')}`,
    },
    notVerifiedSubTitle: 'Проверка персональных данных',
    notVerifiedText:
      'Проверьте ваши персональные данные. Если ошибок нет, нажмите кнопку «Все верно». Если данные не\xa0введены или не\xa0верны, заполните или исправьте\xa0их.',
    requestTitle: 'Заявка на\xa0верификацию',
    requestText:
      'Если вы\xa0уже являетесь владельцем абонемента прошлого сезона, введите номер вашего абонемента. Далее нажмите «Отправить» для проверки вашей заявки сотрудниками клуба.',
    confirmBtn: 'Все верно',
    processingTitle: 'Ожидайте',
    processingText:
      'Заявка отправлена на\xa0обработку сотрудникам клуба. Ожидайте изменения статуса, обработка заявки происходит в\xa0течение 1\xa0рабочего дня.',
    processingNoticePart1:
      'Обращаем ваше внимание, что до\xa0верификации изменить персональные данные в\xa0профиле невозможно. Если у\xa0вас нет необходимости в\xa0верификации, вы\xa0можете перейти ',
    processingNoticePart2: 'к\xa0списку матчей',
    processingNoticePart3: ' для стандартной покупки билетов.',
    verifiedTitle: 'Успешно',
    verifiedText:
      'Ваша заявка успешно обработана и\xa0одобрена сотрудниками клуба. Ожидайте появления кнопки «Выкупить свои места» на\xa0этой странице.',
    verifiedNotice:
      'Обращаем ваше внимание, что в\xa0случае изменения персональных данных в\xa0профиле, верификацию нужно будет пройти повторно.',
    rejectedTitle: 'Заявка отклонена',
    rejectedTextPart1: 'Ваша заявка отклонена клубом. По\xa0всем вопросам вам необходимо ',
    rejectedTextPart2: 'обратиться в\xa0клуб',
    buySeats: 'Выкупить свои места',
  },

  personalizedRansom: {
    toBuy: 'К оплате:',
    title: 'Приоритетный выкуп',
  },
};
